import routes from 'routes';

// The members / visitors list a member of the given club role belongs to. Used to bounce
// back to the RIGHT list (e.g. after editing a member, or when a member-details URL no longer
// resolves) instead of always landing on the Members list. Defaults to Members for staff roles
// (Member / Official / Admin / Owner), for a Guest (the Guest Members page is hidden for every
// club) and when the role is unknown.
export const memberListRouteForRole = (role) =>
  role === 'Visitor'
    ? routes.admin.visitors.members
    : routes.admin.members.members;

export default memberListRouteForRole;
